export default __webpack_public_path__ + "feature3ce042e.png";